import { provideHttpClient } from '@angular/common/http'
import { provideZonelessChangeDetection } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'
import { QueryClient, provideTanStackQuery } from '@tanstack/angular-query-experimental'
import { AppComponent } from './app/app.component'

bootstrapApplication(AppComponent, {
  providers: [provideZonelessChangeDetection(), provideHttpClient(), provideTanStackQuery(new QueryClient())],
}).catch((error) => console.error(error))
